/* eslint-disable react/prop-types */
import React from 'react';
import {
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';

const ProfessionalNeeds = ({ vocPro, setVocPro, globalNeeds }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    }}
  >
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.logistics}
          onChange={() => setVocPro({ ...vocPro, logistics: !vocPro.logistics })}
          name="logistics"
          color="primary"
        />
    )}
      label={`logistics (${globalNeeds.logistics})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.sales}
          onChange={() => setVocPro({ ...vocPro, sales: !vocPro.sales })}
          name="sales"
          color="primary"
        />
    )}
      label={`sales (${globalNeeds.sales})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.marketing}
          onChange={() => setVocPro({ ...vocPro, marketing: !vocPro.marketing })}
          name="marketing"
          color="primary"
        />
    )}
      label={`marketing (${globalNeeds.marketing})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.finance}
          onChange={() => setVocPro({ ...vocPro, finance: !vocPro.finance })}
          name="finance"
          color="primary"
        />
    )}
      label={`finance (${globalNeeds.finance})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.legal}
          onChange={() => setVocPro({ ...vocPro, legal: !vocPro.legal })}
          name="legal"
          color="primary"
        />
    )}
      label={`legal (${globalNeeds.legal})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.engineering}
          onChange={() => setVocPro({ ...vocPro, engineering: !vocPro.engineering })}
          name="engineering"
          color="primary"
        />
    )}
      label={`engineering (${globalNeeds.engineering})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.production}
          onChange={() => setVocPro({ ...vocPro, production: !vocPro.production })}
          name="production"
          color="primary"
        />
    )}
      label={`production (${globalNeeds.production})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.quality}
          onChange={() => setVocPro({ ...vocPro, quality: !vocPro.quality })}
          name="quality"
          color="primary"
        />
    )}
      label={`quality (${globalNeeds.quality})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.it}
          onChange={() => setVocPro({ ...vocPro, it: !vocPro.it })}
          name="it"
          color="primary"
        />
    )}
      label={`it (${globalNeeds.it})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocPro.hr}
          onChange={() => setVocPro({ ...vocPro, hr: !vocPro.hr })}
          name="hr"
          color="primary"
        />
    )}
      label={`hr (${globalNeeds.hr})`}
    />
  </div>
);

export default ProfessionalNeeds;
